import { array, object, record, string, number } from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const targetElementsToRectsSchema = record(string, object({
  top: number,
  left: number,
  width: number,
  height: number
}));
const sendTargetElementRects = defineMessage({
  type: 'sendTargetElementRectsUpdate',
  payloadSchema: object({
    targetElementsToRects: targetElementsToRectsSchema
  })
});
const requestTargetElementRects = defineMessage({
  type: 'requestTargetElementRects',
  payloadSchema: object({
    targetElementSelectors: array(string)
  }),
  reply: sendTargetElementRects
});
export const targetElementRectsMessages = {
  requestTargetElementRects,
  sendTargetElementRects
};